import { render, staticRenderFns } from "./dayiDetail.vue?vue&type=template&id=286c7da4&scoped=true&"
import script from "./dayiDetail.vue?vue&type=script&lang=js&"
export * from "./dayiDetail.vue?vue&type=script&lang=js&"
import style0 from "./dayiDetail.vue?vue&type=style&index=0&id=286c7da4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286c7da4",
  null
  
)

export default component.exports